import { IExport } from '@/@types/Export';
import { useTranslation } from 'react-i18next';

import { useToast } from '@/common/hooks/useToast';
import { generateId } from '../utils';

export function useGetExport() {
  const { t } = useTranslation('common');

  const { toast } = useToast();

  const exportFile = async (data: IExport) => {
    if (!data?.base64) return;
    try {
      const fileId = generateId();
      const fileBase64 = {
        file: `data:application/${data?.type};base64,${data?.base64}`,
        file_name: fileId,
      };
      const anchorElement = document.createElement('a');
      const fileName = `${fileBase64.file_name}.${data?.type}`;
      anchorElement.href = fileBase64.file;
      anchorElement.download = fileName;
      document.body.appendChild(anchorElement);
      anchorElement.click();
      document.body.removeChild(anchorElement);
      toast.success(t('downloadSuccess'));
    } catch (error) {
      toast.error(t('downloadError'));
    }
  };

  return {
    exportFile,
  };
}
